export default __webpack_public_path__ + "static/media/product_placeholder_icon.fb8d2605.svg";